import { render, staticRenderFns } from "./accountsList.vue?vue&type=template&id=a3008324"
import script from "./accountsList.vue?vue&type=script&lang=js"
export * from "./accountsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports